export default "__VITE_ASSET__DtawIsYY__"